// extracted by mini-css-extract-plugin
export default {"button":"_1n941","button-extra":"_12-hL","buttonExtra":"_12-hL","mask":"_15Cfa","wrapper":"_1Aus-","icon":"_22QjH","label":"_3ZJuD"};